import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import TiersContent from "modules/Tiers";
import React from "react";

import { setTitle } from "utilities/helper/setTitle";

const TiersPage: React.FC = () => {
  setTitle("Tiering Management");
  return (
    <Auth>
      <Layout>
        <TiersContent />
      </Layout>
    </Auth>
  );
};

export default TiersPage;
